/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { Button, Switch } from '@insticator/insticator-ui'; // iui-material
// utils
import { url } from '../../../../utils/urls';
// styles
import injectSheet from 'react-jss';
import styles from './addoncontroller_styles';



/* ========== ~~~~~~~~~~ EXPANDABLE SECTION - ADD ON CONTROLLER ~~~~~~~~~~ ========== */
const AddOnController = (props) => {
  const {
    title,
    image,
    description,
    isOpened,
    setIsOpened,
    toggle,
    toggleClick
  } = props;
  return (
    <div className={`addoncontroller ${props.classes.addoncontroller} ${props.className}`}>
        <img src={`${url.image}/${image}`} alt={``} />
        <div className={'cardinner'}>
            <div className={'titletoggle'}>
                <h4 className={'title'}>{title}</h4>
                <Switch on={!!toggle} handleClick={()=>toggleClick(!toggle)} variant={'primary'} />
            </div>
            <div className={'description'}>
                <div className={`descriptiontext`}>
                    {description}
                </div>
                {toggle && !isOpened &&
                <Button name={'edit'} type={'action'} variant={'control'} text={'Edit'} icon={'pen'} action={()=>setIsOpened(!isOpened)} />
                }
            </div>
        </div>
    </div>
  )
};


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(AddOnController);
